/* eslint-disable react/destructuring-assignment */
import {
    SET_ERRORS,
    RESET_REQUEST,
    SET_PAGE,
    SET_MENU_OPEN,
    SET_SPLASH,
} from '../actions/SiteActions';

const initialState = {
    errors: null,
    statusCode: null,
    messages: null,
    page: null,
    pages: {},
    theme: null,
    color: null,
    menuOpen: false,
    splash: window.location.pathname === '/',
    donationUrl: null,
};

const SiteReducer = (previousState, action) => {
    let state = previousState || initialState;
    if (typeof state.hydrated === 'undefined' || !state.hydrated) {
        state = {
            ...initialState,
            ...previousState,
            hydrated: true,
        };
    }
    switch (action.type) {
        case SET_ERRORS:
            return {
                ...state,
                errors: action.payload,
            };
        case SET_PAGE:
            return {
                ...state,
                page: action.payload,
                theme: action.payload.theme,
                pages: {
                    ...state.pages,
                    [action.payload.url]: action.payload,
                },
            };
        case SET_MENU_OPEN:
            return {
                ...state,
                menuOpen: action.payload,
            };
        case SET_SPLASH:
            return {
                ...state,
                splash: action.payload,
            };
        case RESET_REQUEST:
            return {
                ...state,
                errors: null,
                statusCode: null,
                messages: null,
            };
        default:
            return state;
    }
};

export default SiteReducer;
